import PropTypes from "prop-types";
import { getButtonClassName } from "./styles";

export default function Button({
  children,
  className = "",
  variant = "primary",
  size = "md",
  shape = "control",
  ...props
}) {
  return (
    <button
      className={getButtonClassName({ variant, size, shape, className })}
      {...props}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "subtle",
    "ghost",
    "danger",
  ]),
  size: PropTypes.oneOf(["sm", "md", "lg", "icon"]),
  shape: PropTypes.oneOf(["control-sm", "control", "card", "pill"]),
};

Button.defaultProps = {
  className: "",
  variant: "primary",
  size: "md",
  shape: "control",
};
